export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const CHECK_SIGN_STATE = 'CHECK_SIGN_STATE';
export const SWITCH_COMPANY = 'SWITCH_COMPANY';
export const SET_ERROR = 'SET_ERROR';
export const RESET_ERRORS = 'RESET_ERRORS';
export const FORM_BUSY = 'FORM_BUSY';
export const TOUR_AVAILABLE = 'TOUR_AVAILABLE';
